/* eslint-env es2020 */
/**
 * После выкладки хэш чанка меняется, а открытая вкладка держит старый app.js.
 * Браузер запрашивает уже удалённый файл и получает HTML вместо скрипта.
 * Один раз перезагружаем страницу, чтобы подтянуть свежий index.html.
 */

const STORAGE_KEY = 'tcp:chunk-reload-signatures';

let reloadStarted = false;

export function resetChunkReloadState() {
  reloadStarted = false;
}

export function isStaleChunkError(error, filename = '') {
  const name = error && error.name ? String(error.name) : '';
  const message = String((error && error.message) || error || '');
  if (name === 'ChunkLoadError') return true;
  if (/Loading chunk [\w-]+ failed/i.test(message)) return true;
  if (/Loading CSS chunk/i.test(message)) return true;
  if (/Failed to fetch dynamically imported module/i.test(message)) return true;
  if (/error loading dynamically imported module/i.test(message)) return true;
  const file = String(filename || '');
  const scriptUrl = /\.js(\?|$)/i.test(file) || /\/js\//i.test(file);
  return scriptUrl && /Unexpected token ['"]?</.test(message);
}

function signatureOf(error, filename) {
  const message = String((error && error.message) || '');
  const missing = message.match(/missing:\s*(\S+)/i);
  if (missing) return missing[1];
  if (filename) return String(filename);
  return message.slice(0, 300);
}

function rememberedSignatures(session) {
  try {
    const raw = session.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item === 'string') : [];
  } catch {
    return [];
  }
}

function rememberSignature(session, signature) {
  const next = rememberedSignatures(session).filter((item) => item !== signature);
  next.push(signature);
  session.setItem(STORAGE_KEY, JSON.stringify(next.slice(-20)));
}

function browserSession() {
  const root = typeof globalThis !== 'undefined' ? globalThis : null;
  if (!root || !root.window || !root.sessionStorage) return null;
  return root.sessionStorage;
}

function defaultReload() {
  globalThis.window.location.reload();
}

/**
 * @returns {boolean} true, если это устаревший чанк и повторно сообщать об ошибке не нужно
 */
export function recoverFromStaleChunk(error, filename = '', reload = defaultReload) {
  const session = browserSession();
  if (!session) return false;
  if (!isStaleChunkError(error, filename)) return false;
  if (reloadStarted) return true;

  const signature = signatureOf(error, filename);
  if (rememberedSignatures(session).includes(signature)) return false;

  try {
    rememberSignature(session, signature);
  } catch {
    return false;
  }

  reloadStarted = true;
  reload();
  return true;
}
